import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

export const slideDown = trigger('slideDown', [
    transition('* => *', [
        query(':leave', [
            stagger(50, [
                animate('1s ease-out', style({
                    opacity: 0,
                    height: '0px',
                    marginBottom: '0px',
                    paddingTop: '0px',
                    paddingBottom: '0px'
                }))
            ])
        ], { optional: true })
    ])
]);
